import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=a890a70e&scoped=true"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"
import style0 from "./trend.vue?vue&type=style&index=0&id=a890a70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a890a70e",
  null
  
)

export default component.exports